<p-confirmdialog></p-confirmdialog>

@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid; border-radius: 6px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); padding: 10px;">
      You don't have access to this function
    </h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3">
      <h3>Customer Portal</h3>
    </div>
    <!-- Stats bar -->
    @if (stats.length > 0) {
      <div class="grid mb-4">
        <div class="col-12 md:col-4 lg:col-2">
          <div class="surface-card shadow-2 stat-card" style="border-top-color:#3B82F6;">
            <div class="stat-card__header">
              <span class="stat-card__label">Access</span>
              <span class="pi pi-sign-in" style="font-size:1.2rem;color:#3B82F6;opacity:0.7;"></span>
            </div>
            <div class="stat-card__value" style="color:#3B82F6;">{{ statValue('ACCESS') }}</div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-2">
          <div class="surface-card shadow-2 stat-card" style="border-top-color:#8B5CF6;">
            <div class="stat-card__header">
              <span class="stat-card__label">Change Numbers</span>
              <span class="pi pi-users" style="font-size:1.2rem;color:#8B5CF6;opacity:0.7;"></span>
            </div>
            <div class="stat-card__value" style="color:#8B5CF6;">{{ statValue('GUESTS') }}</div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-2">
          <div class="surface-card shadow-2 stat-card" style="border-top-color:#14B8A6;">
            <div class="stat-card__header">
              <span class="stat-card__label">Final Numbers</span>
              <span class="pi pi-check-square" style="font-size:1.2rem;color:#14B8A6;opacity:0.7;"></span>
            </div>
            <div class="stat-card__value" style="color:#14B8A6;">{{ statValue('FINALNUMBERS') }}</div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-2">
          <div class="surface-card shadow-2 stat-card" style="border-top-color:#F97316;">
            <div class="stat-card__header">
              <span class="stat-card__label">Changes Date/Time</span>
              <span class="pi pi-calendar" style="font-size:1.2rem;color:#F97316;opacity:0.7;"></span>
            </div>
            <div class="stat-card__value" style="color:#F97316;">{{ statValue('DATETIME') }}</div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-2">
          <div class="surface-card shadow-2 stat-card" style="border-top-color:#22C55E;">
            <div class="stat-card__header">
              <span class="stat-card__label">Made Payment</span>
              <span class="pi pi-credit-card" style="font-size:1.2rem;color:#22C55E;opacity:0.7;"></span>
            </div>
            <div class="stat-card__value" style="color:#22C55E;">{{ statValue('PAYMENT') }}</div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-2">
          <div class="surface-card shadow-2 stat-card" style="border-top-color:#EF4444;">
            <div class="stat-card__header">
              <span class="stat-card__label">Changed Extras</span>
              <span class="pi pi-shopping-cart" style="font-size:1.2rem;color:#EF4444;opacity:0.7;"></span>
            </div>
            <div class="stat-card__value" style="color:#EF4444;">{{ statValue('EXTRA') }}</div>
          </div>
        </div>
      </div>
    }
    <div class="surface-card p-4 shadow-2 border-round">
      <app-tabview [style]="{'width':'100%'}">
        <app-tabpanel header="Customer Portal" leftIcon="pi pi-globe">
          <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
            <span class="pi pi-info-circle" style="margin-right:2px;"></span>
            Assign a portal template to each package to control what customers can see when viewing their booking.
          </p>
          <p-table #packagesTable
            [value]="packages"
            sortField="name"
            [paginator]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            responsiveLayout="scroll">
            <ng-template #header>
              <tr>
                <th pSortableColumn="_templateName" style="width:180px;">Assigned Template <p-sorticon field="_templateName"></p-sorticon></th>
                <th pSortableColumn="name">Package <p-sorticon field="name"></p-sorticon></th>
                <th style="width:260px;">Change Template</th>
              </tr>
            </ng-template>
            <ng-template #body let-pkg>
              <tr>
                <td>
                  @if (pkg._portaltemplateid) {
                    <span class="template-chip" style="cursor:default; pointer-events:none;"
                      [style.border-color]="getTemplateColour(pkg._portaltemplateid)"
                      [style.background]="getTemplateColour(pkg._portaltemplateid) + '22'">
                      <span class="template-chip__dot" [style.background-color]="getTemplateColour(pkg._portaltemplateid)"></span>
                      <span class="template-chip__name">{{ pkg._templateName }}</span>
                    </span>
                  }
                  @if (!pkg._portaltemplateid) {
                    <span class="text-500 text-sm">None</span>
                  }
                </td>
                <td>{{ pkg.name }}</td>
                <td>
                  <p-select
                    [options]="templateDropdownOptions"
                    [(ngModel)]="pkg._portaltemplateid"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="No template"
                    [style]="{'width':'240px'}"
                    appendTo="body"
                    (onChange)="onPackageTemplateChange(pkg)">
                  </p-select>
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr><td colspan="3" class="text-center text-600 py-4">No packages found.</td></tr>
            </ng-template>
          </p-table>
        </app-tabpanel>
        <app-tabpanel header="Portal Templates" leftIcon="pi pi-th-large">
          <!-- LIST VIEW -->
          @if (!editingTemplate) {
            <div class="flex align-items-center justify-content-between mb-4">
              <p class="m-0 p-0 text-600 line-height-3">
                <span class="pi pi-info-circle mr-1"></span>
                Create templates to control what customers can see and do in the portal.
              </p>
              <button pButton style="height:50px;"
                class="p-button-sm p-button-success ml-3 flex-shrink-0"
                (click)="openNewTemplateDialog()"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add New Template</span></button>
              </div>
              <p-table [value]="templates" sortField="name" [paginator]="true" [rows]="10"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                [rowsPerPageOptions]="[10,25,50]"
                responsiveLayout="scroll">
                <ng-template #header>
                  <tr>
                    <th pSortableColumn="name">Name <p-sorticon field="name"></p-sorticon></th>
                    <th style="width:140px;">Colour</th>
                    <th style="width:100px;"></th>
                    <th style="width:100px;"></th>
                  </tr>
                </ng-template>
                <ng-template #body let-t>
                  <tr>
                    <td>{{ t.name }}</td>
                    <td>
                      <span style="display:inline-block; width:24px; height:24px; border-radius:4px;"
                      [style.background-color]="t.colour"></span>
                    </td>
                    <td>
                      <button pButton type="button" style="margin-left:-20px"
                        class="p-button-sm p-button-success"
                        (click)="selectTemplate(t)">
                        <span class="pi pi-pencil" style="margin-right:8px;"></span>Edit
                      </button>
                    </td>
                    <td>
                      <button pButton type="button" style="margin-left:-20px"
                        class="p-button-sm p-button-danger"
                        (click)="deleteTemplate(t)">
                        <span class="pi pi-trash" style="margin-right:8px;"></span>Delete
                      </button>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr><td colspan="4" class="text-center text-600 py-4">No templates yet. Click <strong>Add</strong> to create one.</td></tr>
                </ng-template>
              </p-table>
            }
            <!-- EDIT VIEW -->
            @if (editingTemplate && selectedTemplate) {
              <!-- Back bar -->
              <div class="flex justify-content-end mb-4">
                <button pButton type="button" class="p-button p-button-sm p-button-outlined"
                  (click)="backToTemplateList()">
                  <span class="pi pi-angle-left" style="margin-right:8px;"></span>
                  <span>Back to List</span>
                </button>
              </div>
              <!-- Template name + colour -->
              <div class="grid formgrid p-fluid mb-2">
                <div class="field col-12 md:col-6">
                  <label class="font-medium">Template Name</label>
                  <input pInputText [(ngModel)]="selectedTemplate.name" placeholder="Template name" />
                </div>
                <div class="field col-12 md:col-6">
                  <label class="font-medium">Template Colour</label>
                  <div class="flex align-items-center gap-3">
                    <p-colorpicker [(ngModel)]="selectedTemplate.colour" format="hex"></p-colorpicker>
                    <input pInputText [(ngModel)]="selectedTemplate.colour"
                      #templateColourInput="ngModel"
                      pattern="^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$"
                      placeholder="#RRGGBB"
                      class="w-8rem text-sm font-mono"
                      [ngClass]="{'ng-invalid ng-dirty': templateColourInput.invalid && templateColourInput.dirty}" />
                      @if (templateColourInput.invalid && templateColourInput.dirty) {
                        <small class="p-error">
                          Must be a valid hex colour (e.g. #FF5733)
                        </small>
                      }
                    </div>
                  </div>
                </div>
                <!-- Rules -->
                <h5 class="mt-2 mb-2 font-medium text-900">Rules</h5>
                <p class="m-0 mb-3 p-0 text-600 line-height-3 mr-3">
                  <span class="pi pi-info-circle" style="margin-right:2px;"></span>
                  Control what each customer can see and do within the portal for this template.
                </p>
                <div class="surface-card p-4 shadow-2 border-round mb-4">
                  @for (rule of selectedTemplate.rules; track rule) {
                    @if (rule.key !== 'status') {
                      <div class="field mb-4 col-12">
                        <label class="font-medium">{{ ruleLabels[rule.key] }}</label>
                        <p-selectbutton
                          [options]="accessOptions"
                          [(ngModel)]="rule.access"
                          optionLabel="label"
                          optionValue="value"
                          [style]="{'width':'300px'}">
                        </p-selectbutton>
                      </div>
                    }
                  }
                  @for (rule of selectedTemplate.rules; track rule) {
                    @if (rule.key === 'status') {
                      <div class="field mb-4 col-12">
                        <label class="font-medium">Show Status</label>
                        <p-selectbutton
                          [options]="statusOptions"
                          [(ngModel)]="rule.access"
                          optionLabel="label"
                          optionValue="value"
                          [style]="{'width':'160px'}">
                        </p-selectbutton>
                      </div>
                    }
                  }
                  @for (rule of selectedTemplate.yesnorules; track rule) {
                    <div class="field mb-4 col-12"
                      [class.rule-locked]="!venueInfoEnabled && (rule.key === 'emailVenue' || rule.key === 'callVenue')">
                      <label class="font-medium">
                        {{ yesNoLabels[rule.key] }}
                        @if (!venueInfoEnabled && (rule.key === 'emailVenue' || rule.key === 'callVenue')) {
                          <span
                            class="pi pi-lock rule-lock-icon ml-1"
                            title="Requires Venue Information to be enabled">
                          </span>
                        }
                      </label>
                      <p-selectbutton
                        [options]="yesNoOptions"
                        [(ngModel)]="rule.enabled"
                        optionLabel="label"
                        optionValue="value"
                        [disabled]="!venueInfoEnabled && (rule.key === 'emailVenue' || rule.key === 'callVenue')"
                        [style]="{'width':'160px'}"
                        (onChange)="onYesNoChange(rule)">
                      </p-selectbutton>
                    </div>
                  }
                </div>
                <!-- Final Numbers -->
                <h5 class="mt-2 mb-2 font-medium text-900">Final Numbers</h5>
                <p class="m-0 mb-3 p-0 text-600 line-height-3 mr-3">
                  <span class="pi pi-info-circle" style="margin-right:2px;"></span>
                  Configure whether customers must confirm their final guest numbers before the booking date.
                </p>
                <div class="surface-card p-4 shadow-2 border-round mb-4">
                  <div class="field mb-4 col-12">
                    <label class="font-medium">Confirm final numbers required</label>
                    <p-selectbutton
                      [options]="yesNoOptions"
                      [(ngModel)]="selectedTemplate.finalnumbersrequired"
                      optionLabel="label"
                      optionValue="value"
                      [style]="{'width':'160px'}"
                      (onChange)="onFinalNumbersRequiredChange()">
                    </p-selectbutton>
                    <div><small class="text-600">Customers must confirm final numbers before the deadline.</small></div>
                  </div>
                  @if (selectedTemplate.finalnumbersrequired) {
                    <div class="field mb-4 col-12 md:col-4">
                      <label class="font-medium">Final numbers due (days before booking)</label>
                      <p-inputnumber
                        [(ngModel)]="selectedTemplate.finalnumbersduebeforebooking"
                        [min]="1"
                        [max]="365"
                        [showButtons]="true"
                        buttonLayout="horizontal"
                        style="display:block; width:160px;">
                      </p-inputnumber>
                    </div>
                    <div class="field mb-0 col-12">
                      <label class="font-medium">Customer must pay outstanding balance when confirming final numbers</label>
                      <p-selectbutton
                        [options]="yesNoOptions"
                        [(ngModel)]="selectedTemplate.mustpayoutstandingbalance"
                        optionLabel="label"
                        optionValue="value"
                        [style]="{'width':'160px'}">
                      </p-selectbutton>
                    </div>
                  }
                </div>
                <!-- Change Booking -->
                <h5 class="mt-2 mb-2 font-medium text-900">Change Booking</h5>
                <p class="m-0 mb-3 p-0 text-600 line-height-3 mr-3">
                  <span class="pi pi-info-circle" style="margin-right:2px;"></span>
                  Set the limits and restrictions for customers making changes to their booking.
                </p>
                <div class="surface-card p-4 shadow-2 border-round mb-4">
                  <div class="field mb-3 col-12">
                    <label class="font-medium">Can customer edit booking on the day</label>
                    <p-selectbutton
                      [options]="yesNoOptionsInverted"
                      [(ngModel)]="selectedTemplate.cannoteditonday"
                      optionLabel="label"
                      optionValue="value"
                      [style]="{'width':'160px'}"
                      (onChange)="onCanEditOnDayChange()">
                    </p-selectbutton>
                  </div>
                  @if (!selectedTemplate.cannoteditonday) {
                    <div class="field mb-4 col-12 md:col-4">
                      <label class="font-medium">Hours before booking start customer can no longer edit</label>
                      <p-inputnumber
                        [(ngModel)]="selectedTemplate.editcutoffhours"
                        [min]="0"
                        [max]="720"
                        [showButtons]="true"
                        buttonLayout="horizontal"
                        style="display:block; width:160px;">
                      </p-inputnumber>
                    </div>
                  }
                  <div class="field mb-3 col-12">
                    <label class="font-medium">Allow number of guests to be changed</label>
                    <p-selectbutton
                      [options]="yesNoOptions"
                      [(ngModel)]="selectedTemplate.changenumberofguestsallowed"
                      optionLabel="label"
                      optionValue="value"
                      [style]="{'width':'160px'}">
                    </p-selectbutton>
                  </div>
                  <div class="field mb-3 col-12">
                    <label class="font-medium">Limit number of changes per booking</label>
                    <p-selectbutton
                      [options]="yesNoOptions"
                      [(ngModel)]="selectedTemplate.limitchangesperbooking"
                      optionLabel="label"
                      optionValue="value"
                      [style]="{'width':'160px'}">
                    </p-selectbutton>
                  </div>
                  @if (selectedTemplate.limitchangesperbooking) {
                    <div class="field mb-4 col-12 md:col-4">
                      <label class="font-medium">Changes allowed</label>
                      <p-inputnumber
                        [(ngModel)]="selectedTemplate.changesallowed"
                        [min]="1"
                        [max]="99"
                        [showButtons]="true"
                        buttonLayout="horizontal"
                        style="display:block; width:160px;">
                      </p-inputnumber>
                    </div>
                  }
                  <div class="field mb-3 col-12">
                    <label class="font-medium">Allow booking to be moved</label>
                    <p-selectbutton
                      [options]="yesNoOptions"
                      [(ngModel)]="selectedTemplate.allowbookingmove"
                      optionLabel="label"
                      optionValue="value"
                      [style]="{'width':'160px'}">
                    </p-selectbutton>
                  </div>
                  @if (selectedTemplate.allowbookingmove) {
                    <div class="field mb-3 col-12">
                      <label class="font-medium">Limit how far a booking can be moved</label>
                      <p-selectbutton
                        [options]="yesNoOptions"
                        [(ngModel)]="selectedTemplate.limitbookingmove"
                        optionLabel="label"
                        optionValue="value"
                        [style]="{'width':'160px'}">
                      </p-selectbutton>
                    </div>
                    @if (selectedTemplate.limitbookingmove) {
                      <div class="field mb-0 col-12 md:col-4">
                        <label class="font-medium">Days from original date</label>
                        <p-inputnumber
                          [(ngModel)]="selectedTemplate.bookingmovelimit"
                          [min]="1"
                          [max]="365"
                          [showButtons]="true"
                          buttonLayout="horizontal"
                          style="display:block; width:160px;">
                        </p-inputnumber>
                      </div>
                    }
                  }
                </div>
                <!-- Bottom Save -->
                <div class="flex justify-content-end mt-3 gap-2">
                  <button pButton type="button" class="p-button-success"
                    (click)="saveTemplate()"><span class="p-button-icon p-button-icon-left pi pi-save" aria-hidden="true"></span><span class="p-button-label">Save Template</span></button>
                    <button pButton type="button" class="p-button-danger"
                      (click)="backToTemplateList()"><span class="p-button-icon p-button-icon-left pi pi-times" aria-hidden="true"></span><span class="p-button-label">Cancel</span></button>
                    </div>
                  }
                </app-tabpanel>
              </app-tabview>
            </div>
          </div>
        }

